export interface SectionHeaderTextProps {
  text: string;
}

const SectionHeaderText = (props: SectionHeaderTextProps) => {
  return <p className="text-sm text-activeTeal font-bold">{props.text}</p>;
};

export default SectionHeaderText;
